module.exports = __webpack_public_path__ + "img/REG_ALIM_SANS_GLUTEN.e9b54a8c.svg";